 
import { Outlet } from "react-router"
import ToposNews from "../news/ToposNews"
import ToposFooter from "./ToposFooter"
import ToposHead from "./ToposHead"

export const labels: string[] = ["today", "day", "week", "month", 'year']


const ToposContainer = ( ) : JSX.Element => { 
    return (                        
        <div className="pe-full-screen-scroll-wrapper overflow-y-visible"> 
            <div className="pe-full-screen-scroll-section topos-first-head">
                <ToposHead />
                <ToposFooter />
            </div>
            <div className="pe-full-screen-scroll-section bg-secondary-light ">
                <ToposNews />
            </div> 
            {/* <ToposVideos /> */} 
            <Outlet />
        </div>  
    )
}

export default ToposContainer